import { render, staticRenderFns } from "./IntroducerLogo.vue?vue&type=template&id=665f237f"
import script from "./IntroducerLogo.vue?vue&type=script&lang=js"
export * from "./IntroducerLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports